'use client';

import { PublicEducator } from '@cademy-package/sdk-component-types';
import GiftPreview from './Preview';
import { VoucherCheckoutState, useVoucherCheckoutState } from './vouchersState';
import { RecipientDetails } from './RecipientDetails';
import { Dispatch, FunctionComponent } from 'react';
import { BuyerDetails } from './BuyerDetails';
import { Payment } from './Payment';
import { Confirmation } from './Confirmation';

import styles from './styles.module.scss';
import Container from '../../../components/Container';

const VoucherCheckoutStep: FunctionComponent<{
    state: VoucherCheckoutState;
    dispatch: Dispatch<Partial<VoucherCheckoutState>>;
}> = ({ state, dispatch }) => {
    switch (state.currentStep) {
        case 'recipientDetails':
            return <RecipientDetails state={state} dispatch={dispatch} />;

        case 'buyerDetails':
            return <BuyerDetails state={state} dispatch={dispatch} />;

        case 'payment':
            return <Payment state={state} dispatch={dispatch} />;

        case 'confirmation':
            return <Confirmation state={state} dispatch={dispatch} />;

        default:
            return null;
    }
};

export type VouchersProps = {
    educator: PublicEducator;
    courseSlug?: string;
};
export const Vouchers: FunctionComponent<VouchersProps> = ({ educator, courseSlug }) => {
    const [state, dispatch] = useVoucherCheckoutState({ educator, courseSlug });

    return (
        <Container className={styles.vouchersPage}>
            <section className={styles.primarySection}>
                <VoucherCheckoutStep state={state} dispatch={dispatch} />
            </section>
            <section>
                <h3>Preview</h3>
                <GiftPreview
                    amount={state.amount}
                    buyerName={state.buyer.firstName}
                    code={state.code}
                    educator_name={educator.name}
                    message={state.message}
                    printout={false}
                    recipientName={state.recipient.firstName}
                    website={educator.links?.web || undefined}
                    cover_url={educator.cover_url}
                    logo_url={educator.logo_url}
                    currency={educator.primaryCurrency}
                />
            </section>
        </Container>
    );
};
